<template>
  <div class="news">
    <!-- banner部分 -->
    <div class="news-banner">
      <div>
        <h2>新闻动态</h2>
      </div>
    </div>
    <!-- 导航部分 -->
    <div class="news-nav">
      <div class="container">
        <ul>
          <li :class="index == current ? 'current' : ''" @click="changeTab(index)" v-for="(item, index) in tabList" :key="index">
            <a href="javascript:void(0)">{{ item }}</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 内容部分 -->
    <div class="news-list clearfix">
      <ul v-for="(newsList, index) in newsItem" :key="index" v-show="current + 1 == index" :class="current == index ? 'container showBox' : 'container'">
        <li v-for="(list, inde) in newsList" :key="inde" v-show="index + current1 == inde" class="home-recdyc item1">
          <div>
            <li v-for="(item, number) in list" :key="number" @click="toDetail(item.title)">
              <div class="news-img fl">
                <img :src="require('../../assets/img/' + item.src)" alt="" />
              </div>
              <div class="news-text fr">
                <h2>{{ item.title }}</h2>
                <p>{{ item.text }}</p>
                <div>
                  <span class="fl">{{ item.date }}</span>
                </div>
              </div>
            </li>
          </div>
        </li>
      </ul>
    </div>
    <!-- 分页部分 -->
    <div class="news-page container clearfix">
      <ul>
        <li class="back-index" @click="tofirst">
          <a href="javascript:void(0)">首页</a>
        </li>
        <li class="back-index" @click="toprev">
          <a href="javascript:void(0)">上一页</a>
        </li>
        <li :class="index == current1 ? 'current' : ''" @click="changeTab1(index)" v-for="(item, index) in pageList" :key="index">
          <a href="javascript:void(0)">{{ item }}</a>
        </li>
        <li class="back-index" @click="tonext">
          <a href="javascript:void(0)">下一页</a>
        </li>
        <li class="back-index" @click="toend">
          <a href="javascript:void(0)">末页</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'News',
  data() {
    return {
      tabList: ['全部', '公司新闻', '公司活动'],
      pageList: ['1', '2', '3'],
      current: 0,
      current1: 0,
      newsItem: {
        1: {
          10: [
            {
              title: '智慧校园建设团队特点及定义',
              text: '智慧校园指的是以物联网为基础的智慧化的校园工作、学习和生活一体化环境，这个一体化环境以各种应用服务系统为载体，将教学、科研、管理和校园生活进行充分融合。2010年，在信息化“十二五”规划中，浙江大学提出建设一个“令人激动”的“智慧校园”。这幅蓝图描绘的是：无处不在的网络学习、融合创新的网络科研、透明高效的校务治理、丰富多彩的校园文化、方便周到的校园生活。简而言之，“要做一个安全、稳定、环保、节能的校园。”2018年6月7日，国家标准《智慧校园总 ...',
              date: '2022-01-23  全部',
              src: 'news/zhxy_image.png',
            },
            {
              title: '智慧物业社区解决方案',
              text: '大家一听到智慧物业这个名称，可能首先会想到智能小区、小区智能管家这一类应用。智慧物业其实就是利用大数据、物联网等先进信息技术手段，通过统一的大数据云平台将物业各个单位紧密连接起来，实现物业单位数据的融合，并且对融合数据进行深度的分析和挖掘，用数据说话，发现在物业管理中方方面面的问题，同时打通部门之间的沟通壁垒，建立起高效的联动机制，从而有效、快速地解决物业管理中方方面面的问题。要想有效处理新时期物业管理工作呈现的问题，一方面要通过完善 ...',
              date: '2022-01-23  全部',
              src: 'news/zhwy_image.png',
            },
          ],
          11: [
            {
              title: '部署行业及产品多元化战略',
              text: '全面提供高校、中职、普教以及政企各行业智慧化解决方案',
              date: '2021-10-21 公司新闻',
              src: 'about/course_Image_one.png',
            },
            {
              title: '斐宸在疫情期间的作为',
              text: '上线校园健康码解决方案',
              date: '2021-09-10 公司新闻',
              src: 'about/course_Image_three.png',
            },
          ],
          12: [
            {
              title: '获得高新技术企业',
              text: '我司承接《上海工商职业技术学院》项目荣获建设银行全国优秀项目；市场覆盖浙江、山东，江苏，陕西．上海等省市20个下辖市。',
              date: '2020-05-11 公司活动',
              src: 'about/course_Image_one.png',
            },
            {
              title: '公司各项专利项目',
              text: '公司完成著作权12项，实用新型专利3项，信息安全管理体系认证2项，信用等级认正1项，质量管理体系认正2项，创新企业培育入库。',
              date: '2020-03-21 公司活动',
              src: 'about/course_Image_three.png',
            },
          ],
        },
        2: {
          20: [
            {
              title: '部署行业及产品多元化战略',
              text: '全面提供高校、中职、普教以及政企各行业智慧化解决方案',
              date: '2021-10-21 公司新闻',
              src: 'about/course_Image_one.png',
            },
          ],
          21: [
            {
              title: '斐宸在疫情期间的作为',
              text: '上线校园健康码解决方案',
              date: '2021-09-10 公司新闻',
              src: 'about/course_Image_three.png',
            },
          ],
          22: [
            {
              title: '斐宸提供测温系统',
              text: '新冠肺炎疫情期间，发布人脸识别测温平板系统',
              date: '2021-05-22 公司新闻',
              src: 'about/course_Image_one.png',
            },
          ],
        },
        3: {
          30: [
            {
              title: '上海斐宸2022年度总结大会圆满落幕！',
              text: '日月更迭，光影流转，时空的坐标轴镌刻每一步奋斗的足迹，记忆的快门声定格每一帧拼搏的瞬间。',
              date: '2023-01-12 年度总结大会',
              src: 'about/summary.png',
            },
          ],
          31: [
            {
              title: '公司各项专利项目',
              text: '公司完成著作权12项，实用新型专利3项，信息安全管理体系认证2项，信用等级认正1项，质量管理体系认正2项，创新企业培育入库。',
              date: '2020-03-21 公司活动',
              src: 'about/course_Image_three.png',
            },
          ],
          32: [
            {
              title: '智慧校园建设配套硬件',
              text: '成功交付自主系统集成项目普教30所，高校5所，政企客户6家完成交付，客户满意度达100%',
              date: '2020-01-22 公司活动',
              src: 'about/course_Image_one.png',
            },
          ],
        },
      },
    };
  },
  methods: {
    toDetail(value) {
      if (value == '上海斐宸2022年度总结大会圆满落幕！') {
        this.$router.push({ name: 'Newsdetail', params: { title: 'true' } });
      } else {
        this.$router.push({ name: 'Newsdetail', params: { title: 'false' } });
      }
    },
    changeTab(index) {
      this.current = index;
      this.current1 = 0;
    },
    changeTab1(index) {
      this.current1 = index;
    },
    toprev() {
      if (this.current1 == 0) {
        this.current1 == 0;
      } else {
        this.current1 -= 1;
      }
    },
    tonext() {
      if (this.current1 == 2) {
        this.current1 = 2;
      } else {
        this.current1 += 1;
      }
    },
    tofirst() {
      this.current1 = 0;
    },
    toend() {
      this.current1 = 2;
    },
  },
};
</script>
<style scoped>
.news-banner {
  width: 100%;
  height: 594px;
  line-height: 594px;
  background: #000;
}
.news-banner div {
  width: 100%;
  height: 100%;
  background: url(../../assets/img/news/background_Image.png) no-repeat;
  background-size: cover;
}
.news-banner h2 {
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.news-nav {
  width: 100%;
  height: 100px;
  line-height: 100px;
  background-color: #eee;
}
.news-nav ul {
  display: table;
  margin-right: -100px;
}
.news-nav li {
  height: 100px;
  float: left;
  margin-right: 99px;
}
.news-nav li.current {
  border-bottom: 4px solid #0076de;
}
.news-nav li:nth-child(1) {
  margin-left: 50px;
}
.news-nav li a {
  font-size: 30px;
  font-weight: 400;
  color: #666;
}
.news-list ul.showBox {
  display: block;
}
.news-list li {
  width: 100%;
  height: 311px;
  margin-top: 100px;
  cursor: pointer;
}
.news-img {
  width: 570px;
  height: 100%;
}
.news-img img {
  width: 100%;
  height: 100%;
}
.news-text {
  position: relative;
  width: 572px;
  height: 100%;
}
.news-text h2 {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.news-text p {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  font-size: 18px;
  font-weight: 400;
  line-height: 1.6;
  color: #666;
}
.news-text div {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 224px;
  font-size: 18px;
  font-weight: 400;
  color: #ccc;
}
.news-text div span {
  display: block;
}
.news-page {
  padding: 85px 0;
  font-size: 18px;
  font-weight: 400;
  color: #333;
}
.news-page ul li {
  float: left;
  margin-right: 20px;
}
.news-page ul li a {
  display: block;
  padding: 20px 25px;
  background: #ffffff;
  box-shadow: 0px 3px 13px 5px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
}
.news-page ul li.current a {
  background: #0076de;
  color: #fff;
}
.back-index {
  width: 140px;
}
.news-page ul li:nth-child(1) {
  margin-left: 100px;
}
.back-index a {
  text-align: center;
}
</style>
